angular.module('userPool')
  .factory('Token', ['http', '$window', function (http, $window) {

    var token = null;
    var renew = null;

    function Token(key) {
      this.key = key;
    }

    Token.prototype.getKey = function () {
      return this.key;
    };

    Token.prototype.toString = function () {
      return this.getKey();
    };

    Token.renew = function () {
      if (renew) return renew;
      return token = renew = http().get('/api/token/renew').then(function (res) {
        $window.setTimeout(function () {
          renew = null;
        }, 5000);
        return new Token(res.data);
      }.bind(this));
    };

    Token.get = function () {
      return token = token || http().get('/api/token').then(function (res) {
        return new Token(res.data);
      });
    };

    return Token;

  }]);
